import { NavLink } from "react-router-dom";
import { LayoutDashboard, ClipboardCheck, Factory, AlertTriangle, BarChart3, Settings } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const ITEMS = [
  { id: "home", label: "Accueil", icon: LayoutDashboard, to: "/", testId: "nav-home-tab" },
  { id: "audits", label: "Audits", icon: ClipboardCheck, to: "/audits", testId: "nav-audits-tab" },
  { id: "sites", label: "Sites", icon: Factory, to: "/sites", testId: "nav-sites-tab" },
  { id: "actions", label: "Actions", icon: AlertTriangle, to: "/actions", testId: "nav-actions-tab" },
  { id: "dashboard", label: "Analyses", icon: BarChart3, to: "/dashboard", testId: "nav-analytics-tab" },
];

export default function BottomNav() {
  const { user } = useAuth();
  const items = user?.role === "ADMIN" ? [...ITEMS, { id: "admin", label: "Admin", icon: Settings, to: "/admin", testId: "nav-admin-tab" }] : ITEMS;

  return (
    <nav
      className="block md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 dark:bg-slate-900/95 backdrop-blur-md border-t border-slate-200 dark:border-slate-800 shadow-lg px-1 py-1.5"
      data-testid="bottom-mobile-nav"
    >
      <div className="flex items-stretch justify-between">
        {items.map(({ id, label, icon: Icon, to, testId }) => (
          <NavLink
            key={id}
            to={to}
            end={to === "/"}
            data-testid={testId}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center gap-0.5 py-1.5 rounded-lg text-[11px] font-medium transition-colors ${
                isActive ? "text-emerald-600 dark:text-emerald-400" : "text-slate-500 dark:text-slate-400"
              }`
            }
          >
            <Icon className="h-5 w-5" />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
